import type { $Fetch } from 'ofetch';
import type { Lead, LeadStatus } from '@/domain/model/Lead';
import type { Page } from '@/domain/model/Page';
import type { LeadGateway } from '@/application/port/out/LeadGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/leads';

export class HttpLeadGateway implements LeadGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: { status?: LeadStatus; pipelineId?: string; vendedorId?: string; page?: number; size?: number }): Promise<Page<Lead>> {
    const params: Record<string, string | number> = {};
    if (p.status) params['status'] = p.status;
    if (p.pipelineId) params['pipelineId'] = p.pipelineId;
    if (p.vendedorId) params['vendedorId'] = p.vendedorId;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<Lead>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<Lead> {
    const res = await this.client<ApiResponse<Lead>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async moverStage(id: string, stageId: string): Promise<Lead> {
    const res = await this.client<ApiResponse<Lead>>(
      `${PATH}/${encodeURIComponent(id)}/mover-stage`,
      { method: 'POST', body: { stageId } },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async marcarPerdido(id: string, lossReasonId: string | null, motivoLivre: string | null): Promise<Lead> {
    const res = await this.client<ApiResponse<Lead>>(
      `${PATH}/${encodeURIComponent(id)}/perdido`,
      { method: 'POST', body: { lossReasonId, motivoLivre } },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
